import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import Text from 'components/_core/Text';
import { Referral, Referrals } from 'features/Referral/hooks/useReferral';
import FinishedReferralsListItem from 'features/Referral/pages/ReferralList/components/FinishedReferralsListItem';

import locales from '../locales';

interface FinishedReferralsHeadersProps {
  referrals: Referrals;
}

const FinishedReferralsList: FC<FinishedReferralsHeadersProps> = ({
  referrals,
}) => {
  if (referrals.length === 0) {
    return null;
  }

  const groupedByYear: Map<number, Referral[]> = new Map();

  referrals.forEach((item) => {
    const year = new Date(item.createdAt).getFullYear();
    if (!groupedByYear.has(year)) {
      groupedByYear.set(year, []);
    }
    groupedByYear.get(year)?.push(item);
  });

  return (
    <Box marginBottom="space-32">
      {Array.from(groupedByYear).map(([year, referralList]) => (
        <Box key={year} marginBottom="space-32">
          {new Date().getFullYear() > year ? (
            <Text color="black" fontWeight="bold" marginBottom="space-16">
              {locales.formatString(locales.onYear, year)}
            </Text>
          ) : null}
          {referralList.map((referral) => (
            <FinishedReferralsListItem
              item={referral}
              key={referral.referralId}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default FinishedReferralsList;
